<template>
  <v-app>
    <template>
    <Navbar></Navbar>
    </template>
    <div class="main_container">
      <router-view></router-view>
      <loader></loader>
    </div>
    <Footer></Footer>
  </v-app>
</template>

<script>
import Navbar from '@/views/Navbar'
import Footer from '@/views/Footer'
import loader from '@/components/Courses/loader'
export default {
  name: 'App',
  components: {
    Navbar,
    Footer,
    loader
  },
  data: () => ({
  }),
  computed: {
    authentication () {
      const user = JSON.parse(localStorage.getItem('user'))
      return !!(user && Object.keys(user).length > 0 && this.$route.meta.authentication)
    }
  },
}
</script>

<style lang="scss">
@import url('https://fonts.googleapis.com/css2?family=Lora:ital,wght@0,400;0,500;0,600;0,700;1,400;1,500;1,600;1,700&family=Poppins:ital,wght@0,300;0,400;0,500;0,600;0,700;1,300;1,400;1,500;1,600;1,700&display=swap');
@import url('./styles/auth.css');
@import './assets/scss/core.scss';
@import url('./assets/icomoon.css');
:root{
  --color-primary: #0EA1DF;
  --color-primary-light: #D6EDF6;
  --color-yellow: #EAC647;
  --color-dark-blue: #243247;
  --color-pink: #F12F28;
  --color-red: #F12F28;
  --color-red2: #EF5F63;
  --color-red-light: #F9BBD9;
  --color-dark: #181818;
  --color-input: #F3F2F4;
  --color-white: #ffffff;
  --color-light-gray: #F3F3F3;
  --color-light-gray2: #DFDFDF;
  --color-grayish: #C4C4C4;
  --shadow-button-red: 0px 0px 15px rgba(236, 19, 19, 0.6);
  --shadow-button-gray: 1px 1px 38px rgba(0, 0, 0, 0.1);

  --font-poppins: 'Poppins', sans-serif;
  --font-lora: 'Lora', serif;
}
*, ::before, ::after {
  box-sizing: border-box;
}
body{
  overflow-x: hidden;
}
body, .v-application {
  font-family: 'Lora', serif !important;
}
.main_container{
  padding-top: 166px;
}
button:focus{
  outline: none !important;
}
.blue_button{
  background-color: var(--color-primary);
  color: #ffffff;
  padding: 5px 16px;
  font-weight: 500;
  border-radius: 3px;
  font-family: var(--font-poppins);
}

.big_blue_button {
  background-color: var(--color-primary) !important;
  color: #ffffff !important;
  padding: 10px 16px !important;
  font-weight: 500;
  border-radius: 3px;
  width: 100%;
  font-family: var(--font-poppins);
  border: none;
  height: auto !important;
  box-shadow: none;
}
.big_blue_button.vbtn--disabled {
  background-color: rgba(0,0,0,.12) !important;
}
.blue_outline_button{
  border: 1px solid var(--color-primary);
  color: var(--color-primary);
  font-weight: 500;
  padding: 4px 16px;
  border-radius: 3px;
  font-family: var(--font-poppins);
}
.yellow_button{
  background: var(--color-yellow);
  color: #000 !important;
  padding: 5px 16px;
  border-radius: 20px;
  font-weight: 600;
  font-size: 12px;
  font-family: var(--font-poppins);
}
.button {
  background-color: var(--color-primary);
  color: #ffffff;
  padding: 5px 16px;
  font-weight: 500;
  border-radius: 3px;
  font-family: var(--font-poppins);
}
.button_red {
  background-color: var(--color-red);
}
.button_block {
  display: block;
  width: 100%;
}
.button_md {
  padding: 0.85rem 1.98rem;
  font-size: 18px;
}
.full_width{
  width: 100%;
}
.medium_btn{
  padding: 10px;
}
.big_btn{
  padding: 16px;
}
.icon_16{
  font-size: 16px !important;
  padding-right: .5rem;
}
.input_form input, .input_form textarea, .input_form select{
  border: 1px solid #ccd;
  padding: 8px;
}
.form_group{
  display: flex;
  flex-direction: column;
  padding-bottom: 1rem;
}

/* Responsive code */
@media (min-width: 1904px){
.container {
    max-width: 1185px;
}
}
</style>
